import { PaginatedList } from '../models/paginated-list';
import { TraceLogs } from '../models/trace-logs';

export const transformTraceLogsResponse = (response: PaginatedList<TraceLogs & { data: [] }>) => ({
  ...response,
  items: response.items.map(item => ({ ...item, data: Array.isArray(item.data) ? null : item.data })),
});
